const hebrewRegex = /[\u0590-\u05FF]/;
const strongCharRegex = /[\u0590-\u05FFA-Za-z]/;

const getDirectionFromText = (textContent = '') => {
  const firstStrongChar = textContent.match(strongCharRegex)?.[0];

  if (!firstStrongChar) {
    return 'ltr';
  }

  return hebrewRegex.test(firstStrongChar) ? 'rtl' : 'ltr';
};

const applyDirection = (el) => {
  el.setAttribute('dir', getDirectionFromText(el.textContent));
};

export default {
  bind(el) {
    applyDirection(el);
  },

  update(el) {
    applyDirection(el);
  }
};
